import PowerfulBtn from "./src";
import type { App } from "vue";

PowerfulBtn.install = function (Vue: App): void {
  console.info("PowerfulBtn----install----");
  Vue.component(PowerfulBtn.name, PowerfulBtn);
};

export default PowerfulBtn;
